export const popups = () => {


	//Close popup
	const closePopupLinksOnPage = document.querySelectorAll('.js__close-popups'); //Get all popup links on page
	
	if(closePopupLinksOnPage.length > 0){ //Check if there are any links first
		closePopupLinksOnPage.forEach((closePopupLink) => { //Loop through each and give it a onclick event listener
			closePopupLink.addEventListener('click', (event) => {
				event.preventDefault(); //Stop the link firing normally !
				closeAllPopups();
				document.querySelector('#js__body').classList.remove('js__popup-active');
			});
		});
	}


}

function openPopup(targetPopupID){
	var targetPopup = document.querySelector(targetPopupID); //Select the popup
	if(targetPopup){ //Check we have a valid target popup
		closeAllPopups()//Make sure no popups are currently open
		targetPopup.classList.add('active'); //Activate the popup!
		document.querySelector('#js__body').classList.add('js__popup-active'); //Add class to body to show popup is open
	}else{
		console.warn('Missing popup: '+targetPopupID);
	}
}


function closeAllPopups(){
	var openPopups = document.querySelectorAll('.popup.active');
	if(openPopups.length > 0){
		openPopups.forEach((openPopup) => {
			openPopup.classList.remove('active');
		});
	}
	let lsubnavModule = document.querySelector('.m__lsubnav');
	if(lsubnavModule){
		lsubnavModule.classList.remove('open');
	}
}




popups();